const dataPrefix = 'data-';
export const startsWithData = new RegExp(`^${dataPrefix}`);

export function dataset(element, key, value) {
  if (element.dataset) {
    if (!key && !value) {
      return element.dataset;
    } else if (value === null) {
      delete element.dataset[key];
    } else if (!value) {
      return element.dataset[key];
    } else {
      element.dataset[key] = value;
    }
  } else {
    const {attributes} = element;

    if (!key && !value) {
      return [...attributes].filter((index) => startsWithData.test(attributes[index].name)).map((index) => attributes[index].value);
    } else if (value === null) {
      element.removeAttribute(dataPrefix + key);
    } else if (!value) {
      return element.getAttribute(dataPrefix + key);
    } else {
      element.setAttribute(dataPrefix + key, value);
    }
  }
}
